module.exports = __webpack_public_path__ + "images/371c97e5.jpg";